// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aQWl","label":"styles_label__1C5uC"};